module.exports = __webpack_public_path__ + "img/arrow.461c51d6.svg";